// Design tokens for aidepo.
// Aesthetic: warm cream background, sage accents, friendly product UI.
// Ported verbatim from designproject/files/tokens.jsx — keep keys identical.

export const T = {
  // Backgrounds
  bg: '#F4F1EC', // app background (warm cream)
  bgAlt: '#EBE6DE', // subtler chrome surface
  surface: '#FFFFFF',
  surfaceAlt: '#FAF7F2',
  surfaceInk: '#1F1B16', // inverse / dark surface for voice modal
  border: '#E5DFD3',
  borderStrong: '#D6CDBC',
  divider: '#EFEAE0',

  // Ink
  ink: '#1F1B16',
  ink2: '#5E5648',
  ink3: '#8C8273',
  ink4: '#B5AC9C',

  // Brand / AI accent — calm sage
  brand: '#4F7B5E',
  brandDeep: '#36583F',
  brandSoft: '#E3EDDF',
  brandSoft2: '#D4E1CD',

  // Safety amber
  safety: '#B0782C',
  safetySoft: '#F2E5C8',

  // Destructive
  danger: '#B6443A',
  dangerSoft: '#F2DCD7',

  // Info (search match)
  info: '#3B68A8',
  infoSoft: '#DCE5F2',

  // Radii (px)
  r1: 8,
  r2: 12,
  r3: 16,
  r4: 20,
  r5: 28,

  // Shadows
  shadow1: '0 1px 2px rgba(31,27,22,0.05), 0 1px 1px rgba(31,27,22,0.03)',
  shadow2: '0 2px 4px rgba(31,27,22,0.06), 0 8px 20px rgba(31,27,22,0.06)',
  shadow3: '0 6px 16px rgba(31,27,22,0.10), 0 24px 56px rgba(31,27,22,0.10)',

  // Type
  font: '"Manrope", -apple-system, "SF Pro Text", system-ui, sans-serif',
  fontMono: '"JetBrains Mono", ui-monospace, Menlo, monospace',
} as const;

export type Palette = typeof T;
